import CardCredentialDeclinedScreen from 'features/cardManagement/screens/cardCredentialChallenge/CardCredentialDeclinedScreen/CardCredentialDeclinedScreen';
import React from 'react';

export default function CardCredentialDeclinedPage() {
  return <CardCredentialDeclinedScreen />;
}
